import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch, FiMapPin } = FiIcons;

const Hero = () => {
  return (
    <div className="relative bg-stone-900 h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 opacity-50 bg-cover bg-center"
        style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&q=80&w=2000")' }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/40 via-stone-900/60 to-stone-900/90"></div>
      </div>

      {/* Decorative SVG Shapes */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-indigo-900/20 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-indigo-900/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 text-center">
        <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-1.5 rounded-full text-white text-sm font-medium mb-6 border border-white/20">
          📍 Charlotte's #1 Wellness Directory
        </div>
        <h1 className="font-playfair text-5xl md:text-7xl text-white font-bold mb-8 drop-shadow-lg tracking-tight">
          Relaxation Redefined in <br/><span className="italic text-indigo-300">Massage World</span>
        </h1>
        <p className="text-xl md:text-2xl text-stone-200 mb-12 max-w-3xl mx-auto font-light leading-relaxed">
          The curated guide to the best massages, day spas, and luxury wellness retreats in the Queen City.
        </p>

        {/* Search Bar */}
        <div className="bg-white rounded-3xl p-3 flex flex-col md:flex-row shadow-2xl max-w-4xl mx-auto border border-white/20">
          <div className="flex-1 flex items-center px-6 py-4 md:py-2 border-b md:border-b-0 md:border-r border-stone-100">
            <SafeIcon icon={FiSearch} className="text-stone-400 w-6 h-6 mr-4" />
            <input 
              type="text" 
              placeholder="Deep tissue, facial, sauna..." 
              className="w-full bg-transparent focus:outline-none text-stone-700 placeholder-stone-400 text-lg"
            />
          </div>
          <div className="flex-1 flex items-center px-6 py-4 md:py-2">
            <SafeIcon icon={FiMapPin} className="text-stone-400 w-6 h-6 mr-4" />
            <input 
              type="text" 
              defaultValue="Charlotte, NC"
              className="w-full bg-transparent focus:outline-none text-stone-700 font-semibold text-lg"
            />
          </div>
          <button className="bg-indigo-900 hover:bg-indigo-950 text-white rounded-2xl px-10 py-5 md:py-3 font-bold text-lg transition-all m-1 shadow-lg hover:shadow-indigo-900/20">
            Find Spas
          </button>
        </div>
        
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-stone-300">
          <span className="text-sm font-bold uppercase tracking-widest opacity-50">Trending:</span>
          <a href="#" className="hover:text-white transition-colors text-sm font-medium hover:underline underline-offset-8">Couples Packages</a>
          <a href="#" className="hover:text-white transition-colors text-sm font-medium hover:underline underline-offset-8">Uptown Hot Spots</a>
          <a href="#" className="hover:text-white transition-colors text-sm font-medium hover:underline underline-offset-8">Sports Therapy</a>
        </div>
      </div>
    </div>
  );
};

export default Hero;